import DownloadsSelector from './DownloadsSelector';

export default DownloadsSelector;
